import React from 'react';
import PropType from 'prop-types';

import Button from '@Components/Button';

import './ExcludeButton.custom.scss';


export default function ExcludeButton (props) {
  const { disableLimit, limitTo } = props;

  return (
    <Button
      onClick={() => limitTo({ exclude: true })}
      disabled={disableLimit}
      buttonConfig={{
        className: 'result-toolbar-exclude-button',
        label: 'Exclude',
        type: 'link',
        size: 'tiny',
        e2eName: 'exclude',
      }}
      iconConfig={{
        position: 'before',
        name: 'forbidden',
        size: 'sm',
      }}
    />
  );
}

ExcludeButton.defaultProps = {
  limitTo: () => {
    Logger.error('limitTo something went wrong, value from ng is not a function');
  },
};

ExcludeButton.propType = {
  limitTo: PropType.func,
  disableLimit: PropType.bool,
};
